import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import { AutoScrollContext } from './context';
import { useOfferContext } from '../OfferContext';
import { trackAutoScroll } from './tracking';

export const AutoScrollProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { position, jsonQuery, offer } = useOfferContext();

  const { state: autoScrollInProgress, setTrue: autoScrollOn, setFalse: autoScrollOff } = useBooleanState(false);

  React.useEffect(() => {
    if (autoScrollInProgress) {
      trackAutoScroll({ jsonQuery, offerId: offer.id, position });
    }
  }, [autoScrollInProgress, jsonQuery, offer, position]);

  if (position % 4 !== 0) {
    return <>{children}</>;
  }

  return (
    <AutoScrollContext.Provider value={autoScrollInProgress}>
      <div onMouseEnter={autoScrollOn} onMouseLeave={autoScrollOff}>
        {children}
      </div>
    </AutoScrollContext.Provider>
  );
};
